import Cookies from 'js-cookie'

const app = {
  state: {
    topNav: true,
    flow: {
      base: [],
      drawer: []
    },
    nowCell: '',
    robotNameCaches: {}, // 用于缓存机器人id回显，减少请求
    sipOpt: [],
    smsOpt: [],
    waOpt: [],
    mailOpt: [],
    groupOpt: [],
    intentionPriorityString: '',
    sidebar: {
      opened: false,
      withoutAnimation: false
    },
    device: 'desktop',
    pageName: '',
    businessType: '',
    businessTags: {},
    showDownloadCenter: false,
    downloadCenterCount: 0,
    logoName: '', // ''是默认airudder，其他情况根据url配置
    stencilGroup: [],
    baseGraph: ''
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    TOGGLE_PAGENAME: (state, pageName) => {
      state.pageName = pageName
    },

    SET_BUSINESS_TYPE: (state, businessType) => {
      state.businessType = businessType
    },
    SET_BUSINESS_TAGS: (state, businessTags) => {
      state.businessTags = businessTags
    },
    CHANGE_SETTING: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value
      }
    },
    TOGGLE_DOWNLOAD_CENTER: (state, showDownloadCenter) => {
      state.showDownloadCenter = showDownloadCenter
      if (showDownloadCenter) state.downloadCenterCount = state.downloadCenterCount + 1
    },
    SET_LOGO_NAME: (state, logoName) => {
      state.logoName = logoName
    },
    SET_STENCIL_GROUP: (state, stencilGroup) => {
      state.stencilGroup = stencilGroup
    }
  },
  actions: {
    toggleDownloadCenter({ commit }, isShow) {
      commit('TOGGLE_DOWNLOAD_CENTER', isShow)
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setPageName({ commit }, pageName) {
      commit('TOGGLE_PAGENAME', pageName)
    },
    changeSetting({ commit }, data) {
      commit('CHANGE_SETTING', data)
    },
    setBusinessType({ commit }, businessType) {
      commit('SET_BUSINESS_TYPE', businessType)
    },
    setBusinessTags({ commit }, businessTags) {
      commit('SET_BUSINESS_TAGS', businessTags)
    },
    setLogoName({ commit }, logoName) {
      commit('SET_LOGO_NAME', logoName)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js